import { forwardRef, type Ref, type SVGProps } from "react";
const IconCarOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M8 17h-.06A1 1 0 0 0 8 19h.06A1 1 0 0 0 8 17m16 0a1 1 0 1 0 1 1 1 1 0 0 0-1-1" />
    <path d="M28.4 13.8 26 12l-.56-4.47a4 4 0 0 0-4-3.53H10.55a4 4 0 0 0-4 3.53L6 12l-2.4 1.8A4 4 0 0 0 2 17v5a2 2 0 0 0 2 2h1v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2h10v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2h1a2 2 0 0 0 2-2v-5a4 4 0 0 0-1.6-3.2M8.72 7.67a2 2 0 0 1 2-1.67h10.59a2 2 0 0 1 2 1.67L24 12h-2a4 4 0 0 0 .05-.5 3.5 3.5 0 0 0-7 0 4 4 0 0 0 .05.5H8zM20 11.5a1.6 1.6 0 0 1-.09.5h-2.82a1.6 1.6 0 0 1-.09-.5 1.5 1.5 0 0 1 3 0M9 26H7v-2h2zm16 0h-2v-2h2zm3-4H4v-5a2 2 0 0 1 .8-1.6L6.67 14h18.66l1.87 1.4A2 2 0 0 1 28 17z" />
  </svg>
);
const ForwardRef = forwardRef(IconCarOutlineSVG);
ForwardRef.displayName = "IconCarOutline";
export { ForwardRef as IconCarOutline };
